import { createSelector } from 'reselect';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import { selectDraggedItemIdsSet } from '../../ducks/dragged_items/selectors';
import type { AppState } from '../../store/types';
import { withSharedCollectionTitle } from './utils';

const getCollectionsFlatTree = (state: AppState) =>
  state.collectionsTree.flatTree;

const getShare = (state: AppState) => state.share.share;

export const selectSharedCollectionsTreeItems = createSelector(
  [getCollectionsFlatTree, getShare],
  (collectionsTree, share) =>
    // biome-ignore lint/plugin: see selectCollectionsTreeItems below.
    collectionsTree.map((item) =>
      withSharedCollectionTitle(item.model, share),
    ) as SearchItemEntity[],
);

export const selectCollectionsTreeItems = createSelector(
  [getCollectionsFlatTree],
  (collectionsTree) =>
    /**
     * The panel declares `items: SearchItemEntity[]`, but a tree node is a
     * TreeReducerModel: it is built from an ObjectWithId, so it has neither a
     * required `title` nor an `object_type`. Retyping the panel's item flow,
     * and checking what the context menu these feed does without those fields,
     * is more than a cast swap.
     */
    // biome-ignore lint/plugin: see above.
    collectionsTree.map((item) => item.model) as SearchItemEntity[],
);

export const selectAllDropTargetIds = createSelector(
  selectCollectionsTreeItems,
  selectDraggedItemIdsSet,
  (items, draggedIds) =>
    items.map((item) => item.id).filter((id) => !draggedIds.has(id)),
);
